import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { ITransmission } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const TransmissionsTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<ITransmission[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const hasEditPermission = hasPermission(['transmissions.edit']);

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) =>
          !header ? null : (
            <span className={`head ${header.customClass}`} key={index}>
              {header.label}
            </span>
          )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item ${hasEditPermission && 'clickable'} has_logo transmissions`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/transmissions/create-transmission/${item.id}`, navigate);
                }}
              >
                <div className="column">{item?.id || '-'}</div>
                <div className="column">{item?.code || '-'}</div>
                <div className="column">
                  <div className="capitalize">{item?.name?.en || '-'}</div>
                </div>
                <div className="column">{item?.description?.en || '-'}</div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/transmissions/create-transmission/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                    <DeleteButton deleteRoute={`/admin/transmissions`} queryKey="transmissions" id={item.id} />
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default TransmissionsTableContainer;
